<!-- CONTAINER STAR -->
<div class="rating-stars"  [style.gap]="gap + 'px'">
    <!-- RATING -->
    <div *ngFor="let star of stars; let i = index" 
            [ngClass]="getStarClass(i)">
    </div>
</div>